class CollectionSubcategoriesSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.sliderContainer = this.querySelector('.swiper');
    this.initSlider();
  }

  async initSlider() {
    if (!this.sliderContainer) return;

    const { Swiper, Navigation } = await import(flu.chunks.swiper);
    
    const swiperOptions = {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector('[data-next]'),
        prevEl: this.querySelector('[data-prev]'),
      }
    };

    this.swiper = new Swiper(this.sliderContainer, swiperOptions);
  }

  connectedCallback() {
    // Already initialized in constructor
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('collection-subcategories-slider', CollectionSubcategoriesSlider);
